import { AlertItem } from './AlertItem';

interface Alert {
  id: string;
  icon: string;
  iconColor: 'warning' | 'critical' | 'success' | 'primary';
  title: string;
  description: string;
  link?: string;
}

export const AlertsList = ({ alerts }: { alerts: Alert[] }) => {
  const actionable = alerts.filter((a) => a.iconColor !== 'success').length;
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold leading-tight tracking-[-0.015em] text-gray-900">
          Alerts &amp; Approvals
        </h2>
        {actionable > 0 && (
          <span className="flex h-6 min-w-6 items-center justify-center rounded-full bg-critical/10 px-2 text-xs font-bold text-critical">
            {actionable}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-3">
        {alerts.map((alert) => (
          <AlertItem key={alert.id} {...alert} />
        ))}
      </div>
    </div>
  );
};
